<template>
  <v-container class="pa-4">
    <v-row no-gutters>
      <v-col cols="12">
        <v-btn
          fab
          x-small
          :color="site.color"
          @click="redirectTo"
          dark
          class="mb-4"
        >
          <v-icon large>mdi-chevron-left</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col class="mx-0 px-0" justify="center" display="grid" cols="12">
        <v-img
          style="border-radius: 50%"
          :aspect-ratio="1"
          height="150px"
          width="150px"
          :src="
            dataFriend.profile_path
              ? dataFriend.profile_path
              : 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'
          "
          class="mx-auto"
        >
        </v-img>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col class="mx-0 px-0 pt-5" justify="center" display="grid">
        <v-row justify="end">
          <v-col
            cols="12"
            class="pa-0 px-4"
            v-for="(item, index) in cardProfile"
            :key="index"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>
                  {{
                    register[index]
                      ? register[index].title
                      : register[index].name
                  }}</v-list-item-title
                >
                <v-list-item-subtitle>{{
                  dataFriend ? dataFriend.detail[item] : dataFriend.detail[item]
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <v-col style="display: flex; justify-content: center">
          <v-btn
            depressed
            color="red"
            dark
            class="my-1"
            style="border-radius: 8px"
            @click="cancelFriend()"
          >
            {{ $t("cancelFriend") }}
          </v-btn>
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>
    
<script>
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
export default {
  name: "profileFriend",
  components: {},
  data() {
    return {
      dataFriend: [],
      cardProfile: [],
      register: [],
      previousRouteName: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // vm คือตัวแทนของ this
      const currentRouteName = to.name;
      if (from?.fullPath && from?.fullPath !== "/") {
        sessionStorage.setItem(
          currentRouteName + "_prev_route_name",
          from.name
        );
        vm.previousRouteName = from.name;
      } else {
        vm.previousRouteName = sessionStorage.getItem(
          currentRouteName + "_prev_route_name"
        );
      }
    });
  },
  mounted() {},
  methods: {
    redirectTo() {
      if (this.previousRouteName) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          name: "friend-list",
        });
      }
    },
    getFriendProfile() {
      Axios.get(
        `friend/getFriendProfile?friend_id=${this.$route.params.id}&user_id=${this.$route.params.user_id}`
      ).then((res) => {
        this.dataFriend = res.data.data;
        this.cardProfile = res.data.data.card_profile.split(",");
        this.register = res.data.data.register_list.elements;
      });
    },
    cancelFriend() {
      Axios.post("friend/cancelFriend", {
        friend_id: this.$route.params.id,
      }).then(() => {
        this.$swal.fire({
          icon: "success",
          text: this.$t("removeFriendSuccess"),
          showConfirmButton: false,
          timer: 2000,
        });
        this.$router.push({ name: "friend-list" });
      });
    },
  },
  created() {
    this.getFriendProfile();
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
  },
};
</script>
    
<style>
.display-card {
  display: flex;
  justify-content: start !important;
}
</style>
